(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.directive('equalHeightLabels', ['$timeout', '$window', function ($timeout, $window) {
			return {
				restrict: 'A',
				link: function (scope, element, attrs, ngModel) {

					scope.$watch('showAddressModal', function (newVal) {
						if (newVal) $timeout(function () { resizeLabels() }, 500)
					});

					angular.element($window).bind('resize', function () {
						if (scope.showAddressModal) {
							resizeLabels();
						}
					});

					function resizeLabels() {
						var maxH = 0;
						var labels = $(element).find('label');
						labels.css('height', 'auto');
						labels.each(function () {
							maxH = Math.max($(this).height(), maxH)
						})
						labels.css('height', maxH);
					}
				}
			}
		}]);
})();
